import gql from 'graphql-tag';

const singleUserFragment = gql`
    fragment UserFragment on UserNode {
        id
        email
        fullName
        firstName
        unitSystem
        hasCreateProjectAccess
    }
`;

export default singleUserFragment;